'use client';

import { useEffect } from 'react';
import type { ReactElement, ReactNode } from 'react';

import { cn } from '../lib/cn';

export interface MobileDrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

export function MobileDrawer({ open, onClose, children }: MobileDrawerProps): ReactElement {
  useEffect(() => {
    if (!open) return;
    function handleKey(e: KeyboardEvent): void {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', handleKey);
    return (): void => window.removeEventListener('keydown', handleKey);
  }, [open, onClose]);

  return (
    <>
      <div
        aria-hidden={!open}
        onClick={onClose}
        className={cn(
          'bg-bg/95 fixed inset-0 z-40 backdrop-blur-xl transition-opacity duration-300',
          open ? 'opacity-100' : 'pointer-events-none opacity-0',
        )}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-hidden={!open}
        style={{ backgroundImage: 'var(--trakd-grad-surface-elevated)' }}
        className={cn(
          'fixed inset-y-0 left-0 z-50 w-[320px] max-w-[90vw]',
          'border-color-violet/15 shadow-trakd-glow-strong border-r',
          'transition-transform duration-300 ease-out',
          open ? 'translate-x-0' : '-translate-x-full',
        )}
      >
        {children}
      </div>
    </>
  );
}
